import { sdkRequest } from '@eventbrite/http';

type GenerateText = {
    prompt: string;
};

type GeneratedText = {
    text: string;
};

export function generateText({ prompt }: GenerateText): Promise<GeneratedText> {
    if (!prompt) {
        throw new Error('You must provide a prompt to generate a text');
    }
    return get_ai_response(prompt);
}

const MAX_ATTEMPTS = 10;
export async function get_ai_response(
    prompt: string,
    retries = MAX_ATTEMPTS,
): Promise<GeneratedText> {
    if (retries > 0) {
        try {
            return await sdkRequest('/api/v3/suggestions/text/', {
                method: 'POST',
                body: JSON.stringify({
                    prompt: prompt,
                }),
            });
        } catch (e) {
            console.log('openai call retry');
            return get_ai_response(prompt, --retries);
        }
    }

    console.log(`Error creating the suggestion after ${MAX_ATTEMPTS} attempts`);
    return Promise.reject({ error: 'Max attempts exceeded' });
}
